<script lang="ts">
    import { onMount } from 'svelte'
    import ZContainerRow from '../../_common/z/z-container-row.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZinputEmpty from '../../_common/z/zinput-empty.svelte'
    import ZinputTitle from '../../_common/z/zinput-title.svelte'
    import Zinput from '../../_common/z/zinput.svelte'

    const segments: { label: string; value: string }[] = [
        { value: 'Clínica estética', label: 'Clínica estética' },
        { value: 'Barbearia', label: 'Barbearia' },
        { value: 'Salão de beleza', label: 'Salão de beleza' },
        { value: 'Estúdio de tatuagem', label: 'Estúdio de tatuagem' },
        { value: 'Consultório', label: 'Consultório' },
        { value: 'outro', label: 'Outro' },
    ]

    let userId: string = ''
    let managerId: string = ''
    let indicatedName: string = ''
    let indicatedPhone: string = ''
    let indicatedSegment: string = ''
    let comments: string = ''

    async function load() {
        //todo
        const urlParams = new URLSearchParams(window.location.search)
        userId = urlParams.get('uid')
        managerId = urlParams.get('mid')
        if (!userId || !managerId) {
            step = 2
            return
        }
        step = 0
    }

    let step = -1
    async function send() {
        //todo
        try {
            await window.api.tools.mgmMembers.create({
                comments,
                indicatedName,
                indicatedPhone,
                indicatedSegment,
                managerId,
                userId,
            })
            step = 1
            window.alert('Pronto!\nEntraremos em contato com você muito em breve.')
        } catch (error) {
            window.error(error)
        }
    }

    onMount(() => {
        load()
    })
</script>

<div class="public_mgm_outer">
    <div class="public_mgm">
        <div class="-mgm-logo"><img src="/img/logo_white.png" /></div>
        <div class="-mgm-somebody">Alguém indicou você:</div>
        <div class="-mgm-title">Zandu: Plataforma Completa de Gestão</div>
        <ul>
            <li>Gestão da agenda com confirmação automática;</li>
            <li>Reagendamento automático de faltas;</li>
            <li>Automações de marketing para vender mais;</li>
            <li>Documentos digitais para evitar papel;</li>
            <li>Assinatura digital de documentos;</li>
            <li>E <b>centenas</b> de outros recursos...</li>
        </ul>
        {#if step === 0}
            <div class="-mgm-text">Preencha para entrarmos em contato:</div>
            <ZContainer>
                <Zinput size={4} label="Seu nome" bind:value={indicatedName} required={true}></Zinput>
                <Zinput size={4} label="Seu WhatsApp" type="tel" required={true} bind:value={indicatedPhone}></Zinput>
                <Zinput size={4} type="select" options={segments} label="Segmento" bind:value={indicatedSegment} required={true}></Zinput>
                <Zinput size={12} label="Comentários?" bind:value={comments}></Zinput>
                <ZContainerRow>
                    <ZinputEmpty total={null}></ZinputEmpty>
                    <Zbutton color="green" label="Enviar" on:click={send}></Zbutton>
                </ZContainerRow>
            </ZContainer>
        {/if}
        {#if step === 1}
            <div class="-mgm-status">Pronto! Entraremos em contato com você muito em breve.</div>
        {/if}
        {#if step === 2}
            <div class="-mgm-status">Ops! Este link parece ser inválido.</div>
        {/if}
    </div>
</div>

<style>
    .public_mgm_outer {
        background-color: #333;
        display: flex;
        width: 100%;
        min-height: 100% !important;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        position: relative;
    }

    .public_mgm {
        width: 100%;
        max-width: 900px;
        padding: 8px;
    }

    .public_mgm ul {
        padding-left: 18px;
    }
    .public_mgm li {
    }

    .public_mgm .-mgm-logo {
        text-align: center;
        margin-bottom: 24px;
    }

    .public_mgm .-mgm-somebody {
        font-size: 19px;
        color: yellow;
        text-align: center;
        margin-bottom: 16px;
    }

    .public_mgm .-mgm-title {
        font-size: 19px;
        margin-bottom: 8px;
    }

    .public_mgm .-mgm-text {
        margin-bottom: 16px;
    }
    .public_mgm .-mgm-status {
        margin-bottom: 16px;
        text-align: center;
        color: yellow;
    }

    .public_mgm .zbutton {
        min-width: 120px;
    }

    @media (max-width: 900px) {
        .public_mgm_outer {
            padding-bottom: 176px;
        }
        .public_mgm ul {
            font-size: 14px;
        }
    }
</style>
